import { Activity, Person } from "@mapmycustomers/shared/types/entity";
import { primaryEntityComparator } from "@mapmycustomers/shared/util/comparator";

const getActivityPeople = (activity: Activity): Person[] => {
  const people = activity.contacts ?? (activity.contact ? [activity.contact] : []);
  if (people.length <= 1) {
    return people;
  }
  return people.toSorted(primaryEntityComparator(activity.contact?.id));
};

export default getActivityPeople;
